import React, { Fragment } from "react";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Stage } from "../../api/getStages/types";

interface ViewStageDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  stage: Stage;
}

const ViewStageDrawer: React.FC<ViewStageDrawerProps> = ({
  isOpen,
  onClose,
  stage,
}) => {
  return (
    <Transition as={Fragment} show={isOpen}>
      <Dialog as="div" className="relative z-40" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="transition-opacity ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <TransitionChild
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <DialogPanel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col bg-white dark:bg-slate-900 shadow-xl">
                    <div className="flex items-center justify-between px-4 py-4 bg-primary">
                      <DialogTitle className="text-lg font-medium text-white">
                        Stage
                      </DialogTitle>
                      <button
                        className="text-white"
                        onClick={onClose}
                        type="button"
                      >
                        <XMarkIcon className="h-6 w-6" />
                      </button>
                    </div>

                    <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6">
                      <dl className="space-y-4">
                        <div>
                          <dt className="text-sm text-gray-500 dark:text-gray-400">
                            Name
                          </dt>
                          <dd className="text-sm text-gray-900 dark:text-white mt-0.5">
                            {stage.name}
                          </dd>
                        </div>
                        <div>
                          <dt className="text-sm text-gray-500 dark:text-gray-400">
                            Position
                          </dt>
                          <dd className="text-sm text-gray-900 dark:text-white mt-0.5">
                            {stage.position}
                          </dd>
                        </div>
                        <div>
                          <dt className="text-sm text-gray-500 dark:text-gray-400">
                            Description
                          </dt>
                          <dd className="text-sm text-gray-900 dark:text-white mt-0.5">
                            {stage.description || "—"}
                          </dd>
                        </div>
                      </dl>
                      <p className="mt-6 text-xs text-gray-500 dark:text-gray-400">
                        Stages are assigned to companies through their
                        subscription and can&apos;t be edited here.
                      </p>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ViewStageDrawer;
